import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stack,
  TextField,
} from "@mui/material";

interface PartnerFormState {
  company_name: string;
  website: string;
  logo: File | null;
}

interface AddPartnerDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
  form: PartnerFormState;
  setForm: React.Dispatch<React.SetStateAction<PartnerFormState>>;
  submitting?: boolean;
}

export default function AddPartnerDialog({
  open,
  onClose,
  onSubmit,
  form,
  setForm,
  submitting = false,
}: AddPartnerDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Add Partner</DialogTitle>

      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <TextField
            label="Company Name"
            fullWidth
            value={form.company_name}
            onChange={(e) =>
              setForm((prev) => ({ ...prev, company_name: e.target.value }))
            }
          />

          <TextField
            label="Website"
            fullWidth
            value={form.website}
            onChange={(e) =>
              setForm((prev) => ({ ...prev, website: e.target.value }))
            }
          />

          <Button variant="outlined" component="label">
            {form.logo ? form.logo.name : "Upload Logo"}
            <input
              type="file"
              hidden
              accept="image/*"
              onChange={(e) => {
                const file = e.target.files?.[0] || null;
                setForm((prev) => ({ ...prev, logo: file }));
              }}
            />
          </Button>
        </Stack>
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} disabled={submitting}>
          Cancel
        </Button>
        <Button variant="contained" onClick={onSubmit} disabled={submitting}>
          Save Partner
        </Button>
      </DialogActions>
    </Dialog>
  );
}
